import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// nodejs library that concatenates classes
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';

import PinDrop from '@mui/icons-material/PinDrop';
// import Phone from '@mui/icons-material/Phone';

import GridContainer from 'components/MaterialKit/Grid/GridContainer.js';
import GridItem from 'components/MaterialKit/Grid/GridItem.js';
import InfoArea from 'components/MaterialKit/InfoArea/InfoArea.js';
import CustomInput from 'components/MaterialKit/CustomInput/CustomInput.js';
import Button from 'components/MaterialKit/CustomButtons/Button.js';
import landingPageStyle from 'assets/jss/nextjs-material-kit-pro/pages/landingPageStyle.js';

import Parallax from 'components/MaterialKit/Parallax/Parallax.js';
import FrontSubsection from 'layouts/FrontSubsection';
import { handleChangeStandardGenerator } from 'components/Custom/FormHandlers';

import { addNotificationMessage } from 'actions/general';

import contactUsStyle from 'assets/jss/nextjs-material-kit-pro/pages/contactUsStyle.js';

const useStyles = makeStyles(landingPageStyle);
const useStylesContact = makeStyles(contactUsStyle);

const ContactUsPage = () => {
    const classes = useStyles();
    const classContact = useStylesContact();
    const dispatch = useDispatch();

    const emptyFormState = {
        name: '',
        emailAddress: '',
        phone: '',
        message: '',
    };
    const [formState, setFormState] = useState(emptyFormState);
    const handleContactSubmit = async () => {
        try {
            const response = await fetch('https://formspree.io/f/xleawarn', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                mode: 'cors',
                body: JSON.stringify(formState),
            });
            setFormState(emptyFormState);
            dispatch(
                addNotificationMessage({
                    message:
            'Your message was successfully submitted to us. We will get back to you soon as we can',
                })
            );
            // Notify successful submission
        } catch (error) {
            // Notify user of fault
            dispatch(
                addNotificationMessage({
                    message: 'Your message failed to be delivered, please try again',
                })
            );
        }
    };
    return (
        <>
            <Parallax image={require('assets/img/mines5.jpg')} filter="dark" small>
                <div className={classes.container}>
                    <GridContainer
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <GridItem xs={12} style={{ textAlign: 'center' }}>
                            <h1 className={classes.title}>Contact Us</h1>
                        </GridItem>
                    </GridContainer>
                </div>
            </Parallax>
            <div className={classNames(classContact.main, classContact.mainRaised)}>
                <div className={classContact.contactContent}>
                    <div className={classContact.container}>
                        <h2 className={classContact.title}>Send us a message</h2>
                        <GridContainer>
                            <GridItem md={6} sm={6}>
                                <p>
                  You can contact us with anything. We
                                    {'\''}ll get in touch with you as soon as possible.
                                </p>
                                <form>
                                    <CustomInput
                                        labelText="Your Name"
                                        id="name"
                                        inputProps={{
                                            value: formState.name,
                                            onChange: handleChangeStandardGenerator(
                                                formState,
                                                setFormState
                                            ),
                                        }}
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Email address"
                                        id="emailAddress"
                                        inputProps={{
                                            value: formState.emailAddress,
                                            onChange: handleChangeStandardGenerator(
                                                formState,
                                                setFormState
                                            ),
                                        }}
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Phone"
                                        id="phone"
                                        inputProps={{
                                            value: formState.phone,
                                            onChange: handleChangeStandardGenerator(
                                                formState,
                                                setFormState
                                            ),
                                        }}
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Your message"
                                        id="message"
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        inputProps={{
                                            value: formState.message,
                                            onChange: handleChangeStandardGenerator(
                                                formState,
                                                setFormState
                                            ),
                                            multiline: true,
                                            rows: 6,
                                        }}
                                    />
                                    <div className={classContact.textCenter}>
                                        <Button color="primary" round onClick={handleContactSubmit}>
                      Submit
                                        </Button>
                                    </div>
                                </form>
                            </GridItem>
                            <GridItem md={4} sm={4} className={classContact.mlAuto}>
                                <InfoArea
                                    className={classContact.info}
                                    title="Find us at"
                                    description={
                                        <p>
                      35 Stirling Hwy, Crawley WA 6009 <br />
                      Australia
                                        </p>
                                    }
                                    icon={PinDrop}
                                    iconColor="primary"
                                />
                                {/* <InfoArea
                                    className={classContact.info}
                                    title="Give us a ring"
                                    description={
                                        <p>
                      Michael Jordan <br /> +40 762 321 762 <br /> Mon - Fri,
                      8:00-22:00
                                        </p>
                                    }
                                    icon={Phone}
                                    iconColor="primary"
                                /> */}
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
        </>
    );
};

ContactUsPage.layout = FrontSubsection;

export default ContactUsPage;
